/**
 * Normalises a coursePointer.query object that may use either camelCase keys
 * (curriculum-service schema) or snake_case keys (wire format).
 */
export const parseCoursePointerQuery = coursePointer => {
  const query = coursePointer?.query || {}
  return {
    courseCode: query.courseCode || query.course_code || null,
  }
}

/**
 * Rewrites (or synthesizes) a coursePointer so fetchCourseTreeFromPointer
 * stores under the same courseCode used by selectCurriculumCourseTree.
 */
export const buildCoursePointerForTreeFetch = (
  coursePointer,
  courseCodeForTree,
) => {
  if (!courseCodeForTree) return coursePointer

  if (!coursePointer) {
    return {
      query: {
        courseCode: courseCodeForTree,
      },
    }
  }

  const query = coursePointer.query || {}
  const existingCode = query.courseCode || query.course_code
  if (existingCode === courseCodeForTree) return coursePointer

  return {
    ...coursePointer,
    query: {
      ...query,
      courseCode: courseCodeForTree,
    },
  }
}
